import { LogoApp as LogoAppUi } from '@xiltrion/ui/bloques/logo-app';
import { appColor } from './app-color';
import { appLogo } from './app-logo';

/**
 * Logo de una app de la suite, a partir de una fila del catálogo (`code`, `icon`, `color`): el SVG oficial de
 * `public/logos` si lo hay, o el que `LogoApp` de `@xiltrion/ui` dibuja con el ícono y el color (dos placas apiladas).
 * El tamaño lo da `className` (`w-36`); es decorativo (el nombre va al lado).
 */
export function LogoApp({ app, sombra, className }: { app: { code: string; icon: string; color?: number | null }; sombra?: boolean; className?: string }) {
  return <LogoAppUi app={{ codigo: app.code, icono: app.icon, color: appColor({ code: app.code, color: app.color ?? null }), logo: appLogo(app.code) }} sombra={sombra} className={className} />;
}
